<template>
  <div class="container-fluid-full">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="page-title m-b-none">
            <h1>Labels</h1>
          </div>
        </div>
        <div class="col-md-8 text-md-right">
          <div class="run-sheet-actions">
            <async-button
              type="button"
              class="btn btn-info"
              :click="handlePrint"
            >
              <font-awesome :icon="['far', 'print']" />
              Print
            </async-button>
          </div>
        </div>
      </div>
      <!-- /.row -->

      <div class="run-details">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-4">
              <div class="form-horizontal">
                <label class="col-md-1 col-lg-2 control-label">User:</label>
                <div class="col-md-11 col-lg-10">
                  <multiselect
                    placeholder
                    :options="users"
                    v-model="user"
                    label="name"
                    track-by="id"
                    :show-labels="false"
                  />
                </div>
              </div>
              <!-- /.form-horizontal-->
            </div>
          </div>
          <!-- /.row -->
        </div>
      </div>
      <!-- /.run-details -->
    </div>

    <div class="run-main">
      <div class="run-left">
        <labels @labelClicked="handleSelected"></labels>
      </div>

      <div class="run-right">
        <iframe class="map" height="100%" width="100%" ref="iframe"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Labels from './Labels'
import { mapActions, mapState } from 'vuex'
import { apiUrl, http } from 'utils'

export default {
  components: {
    Labels
  },

  data () {
    return {
      userId: null,
      selectedLabel: null
    }
  },

  async created () {
    await this.getUsers()
    this.getLabels({ params: { user_id: this.userId } })
  },

  watch: {
    userId () {
      this.getLabels({ params: { user_id: this.userId } })
    }
  },

  computed: {
    ...mapState('auth', { authUser: 'user' }),
    ...mapState('printLogs', ['labels']),
    ...mapState('users', ['users']),

    user: {
      get () {
        return this.users.find(user => user.id === this.userId)
      },
      set (value) {
        if (value) {
          this.userId = value.id
        } else {
          this.userId = null
        }
      }
    },

    labelUrl () {
      if (!this.selectedLabel) {
        return ''
      }
      return apiUrl(`api/v2/print-history/${this.selectedLabel.id}`)
    }
  },

  methods: {
    ...mapActions('printLogs', ['getLabels']),
    ...mapActions('users', ['getUsers']),

    async handleSelected (label) {
      this.selectedLabel = label

      const response = await http.get(`print-history/${this.selectedLabel.id}`, { responseType: 'blob' })
      let objectUrl = null
      if (label.type === 1) {
        objectUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'text/plain' }))
      } else {
        objectUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
      }

      this.$refs.iframe.src = objectUrl
    },

    handlePrint () {
      const content = this.$refs.iframe.contentWindow
      content.focus()
      content.print()
    }
  }
}
</script>
